import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../app/providers.js';

export function ForgotPassword() {
  const { sendPasswordReset, authAvailable } = useAuth();

  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);

    if (!email.trim()) {
      setError('Bitte eine E-Mail eintragen.');
      return;
    }

    setBusy(true);
    const result = await sendPasswordReset(email.trim());
    setBusy(false);

    if (result.ok) setSent(true);
    else setError(result.message ?? 'Der Link konnte nicht verschickt werden.');
  }

  return (
    <section className="ph-auth">
      <p className="ph-auth__kicker">PlatHunt Account</p>
      <h1 className="ph-screen__title">Passwort vergessen</h1>

      {sent ? (
        <p className="ph-notice ph-notice--success" role="status">
          Wenn es zu dieser E-Mail ein Konto gibt, ist der Link unterwegs. Bitte auch den
          Spam-Ordner prüfen.
        </p>
      ) : (
        <>
          <p className="ph-screen__note">
            Wir schicken dir einen Link, mit dem du ein neues Passwort setzen kannst.
          </p>

          {error && (
            <p className="ph-notice ph-notice--error" role="alert">
              {error}
            </p>
          )}

          <form onSubmit={submit} noValidate>
            <label className="ph-field">
              <span className="ph-field__label">E-Mail</span>
              <input
                className="ph-input"
                type="email"
                autoComplete="email"
                inputMode="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={busy || !authAvailable}
              />
            </label>

            <button className="ph-button" type="submit" disabled={busy || !authAvailable}>
              {busy ? 'Wird verschickt …' : 'Link schicken'}
            </button>
          </form>
        </>
      )}

      <div className="ph-authlinks">
        <Link to="/login">Zurück zur Anmeldung</Link>
      </div>
      <p className="ph-todo">
        TODO: Der Screen zum Setzen des neuen Passworts (Rücksprung aus der E-Mail) fehlt noch.
      </p>
    </section>
  );
}
